let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
let hasClicked = false;

items.forEach(item => {
  let summary = item.querySelector("summary");

  item.addEventListener("click", () => hasClicked = true);

  item.addEventListener("mouseover", () => {
    if (!hasClicked) {
      item.setAttribute("open", true);
      summary.setAttribute("aria-expanded", true);
      if(item.querySelector("ul") != null) {
        item.querySelector("ul").addEventListener("mouseleave", () => {
          item.removeAttribute("open");
          summary.setAttribute("aria-expanded", false);
        });
      } else {
        item.querySelector(".megamenu__wrapper").addEventListener("mouseleave", () => {
          item.removeAttribute("open");
          summary.setAttribute("aria-expanded", false);
        })
      }
    }

    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
      summary.setAttribute("aria-expanded", false);
      hasClicked = false;
    });
  });
});
